module.exports = __webpack_public_path__ + "img/nowbangd.bc2f06e5.png";